/**
 * tree转为list
 * @param tree
 * @param {{pid: string}} [options]  定义pid的字段名，如 {pid: 'parentId'}
 * @returns {Array}
 */
export function treeToList(tree = [], options) {
  const pidKey = options?.pid;
  const list = [];
  const _treeToList = (treeArr, pid) => {
    treeArr.forEach((item) => {
      if (item.children) {
        const { children, ...rest } = item;

        if (pidKey && pid && rest) {
          rest[pidKey] = pid;
        }
        list.push(rest);

        _treeToList(children, item.id);
      } else {
        if (pidKey && pid && item) {
          item[pidKey] = pid;
        }
        list.push(item);
      }
    });
  };
  _treeToList(tree);
  return list;
}